import { useEffect, useState } from "react";
import { t } from "i18next";

import RemindmeLogo from "./remindme/assets/icons/logo.svg";
import RemindmeCoop from "./sfuchs/assets/icons/rm_logo_black_coop.svg";
import RemindmeFavicon from "./remindme/assets/icons/favicon.ico";
import RemindMeFeatures from "./remindme/features.json";

import MedionLogo from "./medion/assets/icons/medionLogo.svg";
import MedionFavicon from "./medion/assets/icons/favicon.png";
import MedionFeatures from "./medion/features.json";

import FocusLogo from "./focus/assets/icons/logo.svg";
import FocusFavicon from "./focus/assets/icons/favicon.svg";
import FocusFeatures from "./focus/features.json";

import SfuchsLogo from "./sfuchs/assets/icons/sfuchsBlack.svg";
import SfuchsFavicon from "./sfuchs/assets/icons/favicon.png";
import SfuchsFeatures from "./sfuchs/features.json";

interface FeaturesI {
  socialLogin: {
    facebook: boolean;
    google: boolean;
  };
  selectivePages: {
    ratgeber: boolean;
    topDeals: boolean;
    reminders: boolean;
  };
  changeService: {
    manualSignature: boolean;
  };
}

enum ClientIds {
  "medionApp" = "medionApp",
  "focusApp" = "focusApp",
  "sfuchsApp" = "sfuchsApp",
  "remindmeApp" = "remindmeApp",
}

interface Flavours {
  isRemindme: boolean;
  isMedion: boolean;
  isFocus: boolean;
  isSfuchs: boolean;
  remindmeLogo?: string;
  partnerLogo?: string;
  partnerLink: string;
  footerLogo?: string;
  favicon?: string;
  title: string;
  description: string;
  features: FeaturesI;
  clientId: string;
}

export const useFlavour = () => {
  const initialFlavours = {
    isRemindme: true,
    isMedion: false,
    isFocus: false,
    isSfuchs: false,
    remindmeLogo: undefined,
    partnerLogo: undefined,
    partnerLink: "",
    footerLogo: undefined,
    favicon: undefined,
    title: t("title", { partner: "remind.me" }),
    description: t("description", { partner: "remind.me" }),
    features: RemindMeFeatures,
    clientId: ClientIds.remindmeApp,
  };

  const [flavours, setFlavours] = useState<Flavours>(initialFlavours);

  useEffect(() => {
    // for local testing replace window.location.hostname with "medion" | "focus" | "schnaeppchenfuchs" | "remindme"
    const url = window.location.hostname;
    const flavours = structuredClone(initialFlavours);
    if (url.includes("medion")) {
      flavours.clientId = ClientIds.medionApp;
      flavours.isMedion = true;
      flavours.partnerLogo = MedionLogo;
      flavours.partnerLink = "/";
      flavours.footerLogo = MedionLogo;
      flavours.favicon = MedionFavicon;
      flavours.title = t("title", { partner: "MEDION" });
      flavours.description = t("descriptionMedion");
      flavours.features = MedionFeatures;
    } else if (url.includes("focus")) {
      flavours.clientId = ClientIds.focusApp;
      flavours.isFocus = true;
      flavours.remindmeLogo = RemindmeCoop;
      flavours.partnerLogo = FocusLogo;
      flavours.partnerLink = "https://focus.de";
      flavours.footerLogo = FocusLogo;
      flavours.favicon = FocusFavicon;
      flavours.title = t("title", { partner: "FOCUS" });
      flavours.description = t("description", { partner: "FOCUS" });
      flavours.features = FocusFeatures;
    } else if (url.includes("schnaeppchenfuchs")) {
      flavours.clientId = ClientIds.sfuchsApp;
      flavours.isSfuchs = true;
      flavours.remindmeLogo = RemindmeCoop;
      flavours.partnerLogo = SfuchsLogo;
      flavours.partnerLink = "https://schnaeppchenfuchs.de";
      flavours.footerLogo = SfuchsLogo;
      flavours.favicon = SfuchsFavicon;
      flavours.title = t("title", { partner: "Schäppchenfuchs.com" });
      flavours.description = t("description", { partner: "Schäppchenfuchs.com" });
      flavours.features = SfuchsFeatures;
    } else {
      flavours.clientId = ClientIds.remindmeApp;
      flavours.isRemindme = true;
      flavours.remindmeLogo = RemindmeLogo;
      flavours.footerLogo = RemindmeLogo;
      flavours.favicon = RemindmeFavicon;
      flavours.title = t("title", { partner: "remind.me" });
      flavours.description = t("description", { partner: "remind.me" });
      flavours.features = RemindMeFeatures;
    }
    setFlavours(flavours);
    // eslint-disable-next-line
  }, []);

  return {
    isRemindme: flavours.isRemindme,
    isMedion: flavours.isMedion,
    isFocus: flavours.isFocus,
    isSfuchs: flavours.isSfuchs,
    RemindmeLogo: flavours.remindmeLogo,
    PartnerLogo: flavours.partnerLogo,
    FooterLogo: flavours.footerLogo,
    Favicon: flavours.favicon,
    title: flavours.title,
    description: flavours.description,
    features: flavours.features,
    partnerLink: flavours.partnerLink,
    clientId: flavours.clientId,
  };
};

export const getClientId = () => {
  // for local testing replace window.location.hostname with "medion" | "focus" | "schnaeppchenfuchs" | "remindme"
  const hostname = window.location.hostname;
  if (hostname.includes("medion")) {
    return ClientIds.medionApp;
  } else if (hostname.includes("focus")) {
    return ClientIds.focusApp;
  } else if (hostname.includes("schnaeppchenfuchs")) {
    return ClientIds.sfuchsApp;
  } else {
    return ClientIds.remindmeApp;
  }
};
